define('shared/remote/data/get',[
    './cache',
    '$',
    'shared/util/state',
    'shared/lib/RSVP',
    'shared/lib/URI',
    'shared/lib/console',
    'shared/page/market',
    'shared/page/language'
], 
function(
    cache,
    $,
    state,
    RSVP,
    URI,
    console,
    getMarket,
    getLanguage
){
    'use strict';

    function getByName( dataSourceName ) {
        var market;
        var language;
        var abort = {};

        return RSVP.resolve()
            .then(function(){
                return RSVP.all([getMarket(), getLanguage()]);
            })
            .then(function(values){
                market = values[0];
                language = values[1];

                if (
                    cache && 
                    cache[dataSourceName] && 
                    cache[dataSourceName][market] &&
                    cache[dataSourceName][market][language]
                ) {
                    abort.value = cache[dataSourceName][market][language];
                    return RSVP.resolve(abort);
                }

                return state.retrieve('page.root_path');
            })
            .then(function(rootPath){
                if (arguments[0] === abort) {
                    return RSVP.resolve(arguments[0]);
                }

                var uri = new URI(
                    location.pathname.replace('.html','') + 
                    '/jcr:content/thispartdoesnotexist/data/' + dataSourceName + '.customdata.' + market + '.json'
                );
                return RSVP.resolve(uri.normalize());
            })
            .then(function(dataPath){
                if (arguments[0] === abort) {
                    return RSVP.resolve(arguments[0]);
                }

                return new RSVP.Promise(function(resolve, reject){
                    var dfd = $.ajax({
                        url: dataPath,
                        type: 'GET',
                        dataType: 'json'
                    });
                    dfd.then( resolve, reject );
                });
            })
            .then(RSVP.resolve, function(reason){

                console.warn(
                    'Fail to retrieve data ' + dataSourceName + 
                    ' from server side, try to retrieve communal data from cache...'
                );

                if (
                    cache && 
                    cache[dataSourceName] && 
                    cache[dataSourceName][''] &&
                    cache[dataSourceName][''][language]
                ) {
                    abort.value = cache[dataSourceName][''][language];
                    return RSVP.resolve(abort);
                }
                else {
                    return RSVP.reject(reason);
                }
            })
            .then(function(x){
                if (arguments[0] === abort) {
                    return RSVP.resolve(arguments[0].value);
                }

                cache[dataSourceName] = cache[dataSourceName] || {};
                cache[dataSourceName][market] = cache[dataSourceName][market] || {};
                cache[dataSourceName][market][language] = x;
                
                return RSVP.resolve(x);
            });
    }

    return function( options ) {
        if (
            options == null || 
            options.source == null || 
            options.source.name == null
        ) {
            return RSVP.reject('Parameter is not enough.');
        }

        return getByName(options.source.name);

    };

});
